import React from 'react';
import theme from '../../constants/theme';

export default function Footer() {
  return (
    <footer className="py-8 text-center text-sm" style={{ backgroundColor: theme.bg, color: theme.text }}>
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center opacity-70 gap-4">
<div className="tracking-widest">
  <span className="font-tech font-bold">Mira</span><span className="font-retropix" style={{ color: theme.primary }}>AI.SOL</span>
</div>
        <p>© {new Date().getFullYear()} MiraAI.SOL. All rights reserved.</p>
        <div className="flex gap-6 uppercase text-xs font-bold">
          <a href="#about" className="hover:text-[#c60664]">Story</a>
          <a href="#services" className="hover:text-[#c60664]">Services</a>
          <a href="#contact" className="hover:text-[#c60664]">Contact</a>
        </div>
      </div>
    </footer>
  );
}
